import dayjs from "dayjs";
import ArraySupport from 'dayjs/plugin/arraySupport';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

dayjs.extend(ArraySupport);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

export {
  dayjs
};